import React from 'react';

import { Navigate, RouteObject } from 'react-router-dom';
import MainPage from 'pages/MainPage';
import LoginPage from 'pages/login/LoginPage';
import ScorePage from 'pages/scores/ScorePage';
import AdminRoute from 'pages/admin/AdminRoute';
import AdminLayout from 'pages/admin/AdminLayout';
import UsersListPage from 'pages/admin/UsersListPage';
import BulkUploadPage from 'pages/admin/BulkUploadPage';
import SettingsPage from 'pages/admin/SettingsPage';
import TicketEditorPage from 'pages/admin/TicketEditorPage';
import VotesPage from 'pages/admin/VotesPage';

const routes: RouteObject[] = [
    {
        path: '',
        element: <MainPage />,
    },
    {
        path: 'scores',
        element: <ScorePage />,
    },
    {
        path: 'login',
        element: <LoginPage />,
    },
    {
        path: 'admin',
        element: (
            <AdminRoute>
                <AdminLayout />
            </AdminRoute>
        ),
        children: [
            { index: true, element: <Navigate to="users" replace /> },
            { path: 'users', element: <UsersListPage /> },
            { path: 'users/bulk', element: <BulkUploadPage /> },
            { path: 'ticket', element: <TicketEditorPage /> },
            { path: 'votes', element: <VotesPage /> },
            { path: 'settings', element: <SettingsPage /> },
        ],
    },
];

export default routes;
